import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useQueryClient } from "react-query";
import Divider from "../../../../components/Divider";
import { useGetMessagesActifs } from "../../../../hooks/Messages";
import { Message } from "../../../../services/Api/swagger";
import styles from "./styles";

function BlocInformation() {
  const queriesClient = useQueryClient();

  useEffect(() => {
    queriesClient.invalidateQueries("active-messages");
  }, []);

  const {
    error: errorMessagesActifs,
    isLoading: isFetchingMessagesActifs,
    data: messagesActifs,
  } = useGetMessagesActifs();

  const displayActiveMessages: Message[] = messagesActifs ?? [];

  if (displayActiveMessages.length > 0) {
    return (
      <Box sx={styles}>
        {displayActiveMessages.map((m, index) => (
          <React.Fragment key={index}>
            <Typography variant="h4">{m.titre}</Typography>
            <br />
            <Typography
              sx={{ whiteSpace: "pre-line" }}
              variant="body1"
              dangerouslySetInnerHTML={{ __html: m.contenu }}
            />

            {index === 0 && displayActiveMessages.length === 2 && <Divider />}
          </React.Fragment>
        ))}
      </Box>
    );
  } else return null;
}

export default BlocInformation;
